import { State } from '../hooks/useAppState'
import Box from './Box'
import GrooverText from './GrooverText'
import iconCompleted from '/iconCompleted.svg'
import { memo } from 'react'
import useAppState from '../hooks/useAppState'

type Props = {
  state: State
}

const CourseRegistrationStepFiveClosedContent = ({ state }: Props) => {
  const { state: appState } = useAppState()
  const language = appState.selectedLanguage

  return (
    <Box fullWidth direction="row" align="center" gap="15px">
      {state.isRegistrationCompleted || (!!state.obfuscatedEnrollment?.mainUser && state.isPaid) ? (
        <img src={iconCompleted} alt="Completed icon" width={24} height={24} />
      ) : null}
      <GrooverText textKey="registrationHeadersAndStatusHeaderFinalSummary" language={language} />
    </Box>
  )
}

export default memo(CourseRegistrationStepFiveClosedContent)
